import axios from 'axios'
import { PAYMENT_ENDPOINT } from '../../endpoints'

export async function continuePayment(continueData) {  
    const response = await axios(`${PAYMENT_ENDPOINT}/${continueData}`) //TODO: reemplazar por la url correcta y pasar el parametro
    
    return response?.data
}
